import React from 'react'
import { useSelector } from 'react-redux'
import { useViewport } from '@chilecompra/react-kit'
import { Toast, Typography } from '@chilecompra/react-kit/components'
import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import QuoteListProducts from './QuoteListProducts'
import { Grid } from './QuoteListProducts.styles'

/**
 * The Quote List Products's container.
 */
const QuoteListProductsContainer = () => {
  const { basicInfo, products, loading, error } = useSelector(state => state.quoteBasicInformation)
  const { size } = useViewport()
  const { isBuyer, isSeller } = useAuthorization()

  return (
    (isBuyer || (isSeller && basicInfo.statusId !== 2)) && (
      <>
        <Grid container padding={size.isDownToTiny ? '8px 0 0' : '41px 0 0'}>
          <Grid item xs={12}>
            <Typography color="black1" fontSize="22px" fontWeight="bold" lineHeight="26px" variant="h3">
              Listado de productos solicitados
            </Typography>
          </Grid>
        </Grid>
        {!loading && error && (
          <Grid container margin="16px 0 24px">
            <Grid item xs={12}>
              <Toast severity="error" title="Lo sentimos, estamos presentando problemas con nuestro servidor.">
                En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos
                minutos más.
              </Toast>
            </Grid>
          </Grid>
        )}
        <Grid container padding={size.isDownToTiny ? '8px 0' : '20px 0 0'}>
          <Grid item xs={12}>
            {products.map(product => (
              <QuoteListProducts
                code={product.productCode}
                description={product.description}
                key={product.id}
                name={product.name}
                quantity={product.quantity}
                unitMeasure={product.unitMeasure}
              />
            ))}
          </Grid>
        </Grid>
      </>
    )
  )
}

export default QuoteListProductsContainer
